import React from "react"

const StyledCheckbox = ({
    labelStyle,
    labelClassName,
    style,
    iconClassName,
    onEventChange,
    children,
    ...rest
}) => (
    <label style={labelStyle} className={labelClassName}>
        <input
            type="checkbox"
            onChange={onEventChange}
            style={{ ...style, display: "none" }}
            {...rest}
        />
        <span className={`icon icon-${iconClassName}`} />
        {children}
    </label>
)

export default StyledCheckbox
